/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AttributeSystemName,
  GetGlobalListParams,
  GlobalListResponse,
  GlobalListType,
  SegmentationId
} from './data.schemas'




export const getAllGlobalLists = (
    segmentationId: SegmentationId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GlobalListResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/globallists/all`,options
    );
  }


export const getGetAllGlobalListsQueryKey = (segmentationId: SegmentationId,) => {
    return [`/api/segment/${segmentationId}/globallists/all`] as const;
    }

    
export const getGetAllGlobalListsQueryOptions = <TData = Awaited<ReturnType<typeof getAllGlobalLists>>, TError = AxiosError<unknown>>(segmentationId: SegmentationId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGlobalLists>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllGlobalListsQueryKey(segmentationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllGlobalLists>>> = ({ signal }) => getAllGlobalLists(segmentationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllGlobalLists>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAllGlobalListsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllGlobalLists>>>
export type GetAllGlobalListsQueryError = AxiosError<unknown>

export const useGetAllGlobalLists = <TData = Awaited<ReturnType<typeof getAllGlobalLists>>, TError = AxiosError<unknown>>(
 segmentationId: SegmentationId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllGlobalLists>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAllGlobalListsQueryOptions(segmentationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGlobalListOrder = (
    segmentationId: SegmentationId,
    attributeSystemName: AttributeSystemName, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/globallists/order/${encodeURIComponent(String(attributeSystemName))}`,options
    );
  }


export const getGetGlobalListOrderQueryKey = (segmentationId: SegmentationId,
    attributeSystemName: AttributeSystemName,) => {
    return [`/api/segment/${segmentationId}/globallists/order/${attributeSystemName}`] as const;
    }

    
export const getGetGlobalListOrderQueryOptions = <TData = Awaited<ReturnType<typeof getGlobalListOrder>>, TError = AxiosError<unknown>>(segmentationId: SegmentationId,
    attributeSystemName: AttributeSystemName, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalListOrder>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGlobalListOrderQueryKey(segmentationId,attributeSystemName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGlobalListOrder>>> = ({ signal }) => getGlobalListOrder(segmentationId,attributeSystemName, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId && attributeSystemName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGlobalListOrder>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGlobalListOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getGlobalListOrder>>>
export type GetGlobalListOrderQueryError = AxiosError<unknown>

export const useGetGlobalListOrder = <TData = Awaited<ReturnType<typeof getGlobalListOrder>>, TError = AxiosError<unknown>>(
 segmentationId: SegmentationId,
    attributeSystemName: AttributeSystemName, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalListOrder>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetGlobalListOrderQueryOptions(segmentationId,attributeSystemName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGlobalList = (
    segmentationId: SegmentationId,
    globalListType: GlobalListType,
    params?: GetGlobalListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/globallists/${encodeURIComponent(String(globalListType))}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetGlobalListQueryKey = (segmentationId: SegmentationId,
    globalListType: GlobalListType,
    params?: GetGlobalListParams,) => {
    return [`/api/segment/${segmentationId}/globallists/${globalListType}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetGlobalListQueryOptions = <TData = Awaited<ReturnType<typeof getGlobalList>>, TError = AxiosError<unknown>>(segmentationId: SegmentationId,
    globalListType: GlobalListType,
    params?: GetGlobalListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalList>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGlobalListQueryKey(segmentationId,globalListType,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGlobalList>>> = ({ signal }) => getGlobalList(segmentationId,globalListType,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId && globalListType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGlobalList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGlobalListQueryResult = NonNullable<Awaited<ReturnType<typeof getGlobalList>>>
export type GetGlobalListQueryError = AxiosError<unknown>

export const useGetGlobalList = <TData = Awaited<ReturnType<typeof getGlobalList>>, TError = AxiosError<unknown>>(
 segmentationId: SegmentationId,
    globalListType: GlobalListType,
    params?: GetGlobalListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlobalList>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetGlobalListQueryOptions(segmentationId,globalListType,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



